import React from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {BookingSearchResultRecordCardViewComponent} from "./booking-search-result-record-card-view.component";
import {
    IBookingSearchResultRecordViewModel
} from "../../../../services/agency-booking-search/booking-search-result-record.view-model.interface";
import {
    IBookingSearchStrategyViewModel
} from "../../../../services/agency-booking-search/strategies/booking-search.strategy.interface";

const CardsContainerBox = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: ${props => props.theme.spacing.spacing20};
    padding-bottom: ${props => props.theme.spacing.spacing20};
    padding: 0 
            ${props => props.theme.spacing.spacing8} 
            ${props => props.theme.spacing.spacing20}
            0;
    
    ${props => props.theme.screenMediaQuery.mAndBelow} {
        grid-template-columns: 1fr 1fr;
    }
    
    ${props => props.theme.screenMediaQuery.xsAndBelow} {
        grid-template-columns: 1fr;
    }
`

export const BookingSearchResultsCardsViewComponent: React.FC<{results: IBookingSearchResultRecordViewModel[]; currentStrategy: IBookingSearchStrategyViewModel}> = observer((props) => {

    return (
        <CardsContainerBox>
            {props.results.map(((record) => <BookingSearchResultRecordCardViewComponent key={record.uniqueKey}
                                                                                        record={record}
                                                                                        currentStrategy={props.currentStrategy}/>))}
        </CardsContainerBox>
    )
})